import React, { useCallback, useEffect } from 'react';

import { useTranslate } from '@/hooks/useTranslate';
import useAvatarsStore from '@/store/Avatars';

import AvatarItem, { AvatarState } from '../Common/AvatarItem';
import Title from '../Common/Title';

interface AvatarLibraryProps {
  isLoggedIn: boolean;
  onSelect?: (avatar: any) => void;
}

const AvatarLibrary: React.FC<AvatarLibraryProps> = ({ isLoggedIn, onSelect }) => {
  const { t } = useTranslate();
  const templateAvatarOrginData = useAvatarsStore(
    (store) => store.templateAvatarOrginData,
  );
  const getTemplateAvatarsList = useAvatarsStore((store) => store.getTemplateAvatarsList);
  const videoMute = useAvatarsStore((store) => store.videoMute);
  const setVideoMute = useAvatarsStore((store) => store.setVideoMute);

  const fetchData = async () => {
    try {
      await getTemplateAvatarsList();
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  };

  useEffect(() => {
    // 如果未登录，不请求接口
    if (!isLoggedIn) {
      return;
    }
    fetchData();
  }, [isLoggedIn]);

  const handleMuteToggle = useCallback(
    (bool: boolean) => {
      setVideoMute(bool);
    },
    [setVideoMute],
  );

  return (
    <div className="flex flex-col gap-[16px]">
      <Title title={t('merror.avatars.hotTitle')} />
      <div className="library-avatar flex gap-[16px] pb-[12px] flex-wrap">
        {templateAvatarOrginData.map((item) => {
          const mutableExtend = JSON.parse(item.mutableExtend) || {};
          const isPro = mutableExtend?.isPro === 1 ? true : false;
          const immutableExtend = JSON.parse(item.immutableExtend) || {};
          const previewUrl = immutableExtend?.tobPreviewVideo || item.previewUrl;

          return (
            <AvatarItem
              type="template"
              itemData={item}
              key={item.templateCode}
              coverUrl={item.icon}
              videoUrl={previewUrl}
              name={item.title}
              state={AvatarState.NORMAL}
              isPro={isPro}
              isMute={videoMute}
              onMute={handleMuteToggle}
              onUpgrade={() => {}}
              onUpdated={() => {}}
              onSelect={onSelect}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AvatarLibrary;
